import React from 'react';
import './PromptExample.css';

const examples = [
  {
    category: 'Startup App',
    prompt: 'Build a mobile app for food delivery where users can browse restaurants, place orders, and track deliveries in real time.',
  },
  {
    category: 'Admin Dashboard',
    prompt: 'Create a responsive web dashboard for managing inventory, orders, and users with role-based access control.',
  },
  {
    category: 'AI Tool',
    prompt: 'Develop a web tool that allows users to summarize PDFs or articles using ChatGPT and download the result.',
  },
  {
    category: 'Booking Website',
    prompt: 'Design a website for booking beauty salon appointments with calendar integration and staff management.',
  },
  {
    category: 'Portfolio Site',
    prompt: 'Make a modern portfolio website for a UI/UX designer with case studies, testimonials, and contact form.',
  },
];

const PromptExample = () => {
  return (
    <div className="prompt-container">
      <div className="prompt-hero">
        <h1 className="prompt-title">Prompt Examples</h1>
        <p className="prompt-subtitle">
          Not sure what to write? Here are some prompts to help you describe your project idea clearly.
        </p>
      </div>

      <div className="prompt-list">
        {examples.map((example, index) => (
          <div className="prompt-card" key={index}>
            <h3>{example.category}</h3>
            <p>"{example.prompt}"</p>
          </div>
        ))}
      </div>

      <div className="prompt-cta">
        <h2>Got an Idea of Your Own?</h2>
        <p>Use the quotation tool to describe your project — AI will handle the rest.</p>
        <button onClick={() => window.open('/project_prompt', '_blank')}>
          Try the Generator
        </button>
      </div>
    </div>
  );
};

export default PromptExample;
